import React from 'react'
import { Button } from '@mui/material'
import ActionWrapper from '../action-wrapper'
import type { ActionButtonProps } from '../action-wrapper/types'

const ActionButton: React.FC<ActionButtonProps> = ({
  icon,
  variant,
  color,
  label,
  hiddenActions = [],
  onClick,
  testId,
  anchorEl,
  isMenuOpen,
  setIsMenuOpen,
  disabled,
}) => (
  <ActionWrapper
    isMenuOpen={isMenuOpen}
    setIsMenuOpen={setIsMenuOpen}
    anchorEl={anchorEl}
    hiddenActions={hiddenActions}
  >
    <Button
      data-testid={testId}
      startIcon={icon}
      size="medium"
      variant={variant}
      color={color}
      onClick={onClick}
      fullWidth
      disabled={disabled}
    >
      {label}
    </Button>
  </ActionWrapper>
)

export default ActionButton
